import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";
import { IContent } from "@kunduz/data-access-cms-api";

const MobileLazyLoadedTop = dynamic<any>(
  () => {
    return import("./mobileTop").then((module) => module.MobileTop);
  },
  {
    ssr: false,
    loading: () => (
      <div style={{ display: "flex", gap: 12 }}>
        <LoadingSkeleton style={{ width: 120, height: 34 }} />
      </div>
    ),
  },
);

export const MobileTopLoader = (props: {
  headerType: "student" | "teacher" | "school";
  mobileTopCmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}): ReactElement => {
  return <MobileLazyLoadedTop {...props} />;
};
